import {GET_USER_CONTACTS, GET_USER_CONTACTS_FAIL, SELECT_CONTACT, SELECT_GROUP} from '../actions/typesAction';

const initialState = {
    contacts: [],
    selectedContact: null,
    selectedGroup: null
};

export default function contactReducer(state = initialState, action) {
    const {type, payload} = action;

    switch (type) {
        case GET_USER_CONTACTS:
            return {
                ...state,
                contacts: payload,
            };
        case GET_USER_CONTACTS_FAIL:
            return {
                ...state,
                contacts: [],
            }
        case SELECT_CONTACT:
            return {
                ...state,
                selectedGroup: null,
                selectedContact: payload,
            }
        case SELECT_GROUP:
            return {
                ...state,
                selectedContact: null,
                selectedGroup: payload,
            }
        default:
            return state;
    }
}
